import React from 'react';
import { Link } from 'react-router-dom';

const PrivacyPage = () => {
  return (
    <div className="min-h-screen bg-background text-foreground py-16 px-6">
      <div className="max-w-3xl mx-auto">
        {/* Logo / Back link */}
        <Link to="/" className="inline-flex items-center space-x-3 mb-12 hover:opacity-80 transition-opacity">
          <img
            src="/brand/depthme-icon-192.png"
            alt="DepthMe Logo"
            className="w-10 h-10 object-contain"
          />
          <span className="text-lg font-semibold text-foreground">DepthMe</span>
        </Link>

        <h1 className="text-4xl font-bold text-foreground mb-2">Privacy Policy</h1>
        <p className="text-sm text-muted-foreground/60 mb-10">Last updated: April 2026</p>

        <div className="glassmorphism rounded-2xl p-8 space-y-8">

          <div>
            <h2 className="text-base font-semibold text-accent mb-3">Who We Are</h2>
            <p className="text-muted-foreground leading-relaxed">
              DepthMe is a personal growth and spiritual guidance application. We are committed to protecting your privacy and providing a safe space for reflection and growth.
            </p>
          </div>

          <div>
            <h2 className="text-base font-semibold text-accent mb-3">Information We Collect</h2>
            <p className="text-muted-foreground leading-relaxed mb-3">
              We collect only the information necessary to personalize your experience, including:
            </p>
            <ul className="list-disc pl-5 space-y-1 text-muted-foreground">
              <li>Account information (email address, display name)</li>
              <li>Personal goals and survey responses you provide</li>
              <li>Journal entries and ritual session records</li>
              <li>Usage patterns within the app</li>
            </ul>
          </div>

          <div>
            <h2 className="text-base font-semibold text-accent mb-3">How We Use Your Information</h2>
            <p className="text-muted-foreground leading-relaxed mb-3">
              Your information is used exclusively to:
            </p>
            <ul className="list-disc pl-5 space-y-1 text-muted-foreground">
              <li>Personalize your daily AI-generated guidance</li>
              <li>Track your progress and streaks</li>
              <li>Improve the app experience</li>
            </ul>
          </div>

          <div>
            <h2 className="text-base font-semibold text-accent mb-3">AI-Generated Content</h2>
            <p className="text-muted-foreground leading-relaxed">
              We use AI services (OpenAI) to generate personalized guidance based on your goals and survey answers. Your personal data is sent to OpenAI solely for this purpose and is not used to train public AI models. We do not sell, rent, or share your data with third parties for marketing purposes.
            </p>
          </div>

          <div>
            <h2 className="text-base font-semibold text-accent mb-3">Your Journal is Private</h2>
            <p className="text-muted-foreground leading-relaxed">
              Your journal entries are private and stored securely. They are never shared publicly or visible to other users.
            </p>
          </div>

          <div>
            <h2 className="text-base font-semibold text-accent mb-3">Data Storage</h2>
            <p className="text-muted-foreground leading-relaxed">
              Your data is stored securely using Supabase (PostgreSQL), hosted on AWS infrastructure. Data is encrypted at rest and in transit.
            </p>
          </div>

          <div>
            <h2 className="text-base font-semibold text-accent mb-3">Authentication</h2>
            <p className="text-muted-foreground leading-relaxed">
              We offer sign-in via Google OAuth and email/password. When you sign in with Google, we receive your email address and name. We do not receive your Google password or access to other Google services.
            </p>
          </div>

          <div>
            <h2 className="text-base font-semibold text-accent mb-3">Your Rights</h2>
            <p className="text-muted-foreground leading-relaxed mb-3">
              You have the right to:
            </p>
            <ul className="list-disc pl-5 space-y-1 text-muted-foreground">
              <li>Access the personal data we hold about you</li>
              <li>Request correction of inaccurate data</li>
              <li>Request deletion of your account and all associated data</li>
              <li>Export your data at any time</li>
            </ul>
            <p className="text-muted-foreground leading-relaxed mt-3">
              To exercise any of these rights, contact us at{' '}
              <a href="mailto:hello@depthme.app" className="text-primary hover:underline">
                hello@depthme.app
              </a>.
            </p>
          </div>

          <div>
            <h2 className="text-base font-semibold text-accent mb-3">Payments</h2>
            <p className="text-muted-foreground leading-relaxed">
              Subscription payments are processed by Stripe. We do not store your payment card details. Stripe's privacy policy applies to payment data.
            </p>
          </div>

          <div>
            <h2 className="text-base font-semibold text-accent mb-3">Changes to This Policy</h2>
            <p className="text-muted-foreground leading-relaxed">
              We may update this policy periodically. We will notify you of significant changes via email or in-app notification.
            </p>
          </div>

          <div>
            <h2 className="text-base font-semibold text-accent mb-3">Contact</h2>
            <p className="text-muted-foreground leading-relaxed">
              For privacy-related questions:{' '}
              <a href="mailto:hello@depthme.app" className="text-primary hover:underline">
                hello@depthme.app
              </a>
            </p>
          </div>

        </div>

        <Link to="/" className="inline-flex items-center space-x-2 mt-10 text-sm text-primary hover:underline">
          <span>←</span>
          <span>Back to DepthMe</span>
        </Link>
      </div>
    </div>
  );
};

export default PrivacyPage;
